import Vue from "vue";
import Router from "vue-router";
Vue.use(Router);

export default new Router({
    mode:'history',
    routes: [
        //攻略
        {
            path: "/strategyHome",
            name: "strategyHome",
            component: () => import("@/components/strategy/strategyHome"),
            children: []
        },
        //稿件活动详情
        {
            path: "/strategyDetail",
            name: "strategyDetail",
            component: () => import("@/components/strategy/strategyDetail")
        },
        //发布的稿件详情
        //稿件活动详情
        {
            path: "/gaojianDetail",
            name: "gaojianDetail",
            component: () => import("@/components/strategy/gaojianDetail")
        },
        //攻略详情
        {
            path: "/tourismDetail",
            name: "tourismDetail",
            component: () => import("@/components/strategy/tourismDetail")
        },
        //发布文章
        {
            path: "/whiteTxt",
            name: "whiteTxt",
            component: () => import("@/components/strategy/whiteTxt")
        },
        //首页新增的小页面
        {
            path: "/homePages",
            name: "homePages/partnerFwb",
            // redirect: "/homePages/partnerFwb",
            component: () => import("@/components/homeTop/homePages"),
            children: [
                {
                    path: "/partnerFwb",
                    name: "partnerFwb",
                    component: () => import("@/components/homeTop/partnerFwb")
                },
            ]
        },
        //景区,用票
        {
            path: "/scenic",
            name: "scenic",
            redirect: "/scenic/scenicHome",
            component: () => import("@/components/scenic/scenic"),
            children: [
                {
                    path: "scenicHome",
                    name: "scenicHome",
                    component: () => import("@/components/scenic/scenicHome")
                },
                {
                    path: "scenicList",
                    name: "scenicList",
                    component: () => import("@/components/scenic/scenicList")
                },
                {
                    path: "scenicDetail",
                    name: "scenicDetail",
                    component: () => import("@/components/scenic/scenicDetail")
                },
                {
                    path: "scenicSubmit",
                    name: "scenicSubmit",
                    component: () => import("@/components/scenic/scenicSubmit")
                }
            ]
        },
        //酒店
        {
            path: "/hotel",
            name: "hotel",
            redirect: "/hotel/hotelHome",
            component: () => import("@/components/hotel/hotel"),
            children: [
                {
                    path: "hotelHome",
                    name: "hotelHome",
                    component: () => import("@/components/hotel/hotelHome")
                },
                {
                    path: "hotelList",
                    name: "hotelList",
                    component: () => import("@/components/hotel/hotelList")
                },
                {
                    path: "hotelDetail",
                    name: "hotelDetail",
                    component: () => import("@/components/hotel/hotelDetail")
                },
                {
                    path: "hotelSubmit",
                    name: "hotelSubmit",
                    component: () => import("@/components/hotel/hotelSubmit")
                }
            ]
        },
        //旅游
        {
            path: "/travel",
            name: "travel",
            redirect: "/travel/travelHome",
            component: () => import("@/components/travel/travel"),
            children: [
                {
                    path: "travelHome",
                    name: "travelHome",
                    component: () => import("@/components/travel/travelHome")
                },
                {
                    path: "travelList",
                    name: "travelList",
                    component: () => import("@/components/travel/travelList")
                },
                {
                    path: "travelDetail",
                    name: "travelDetail",
                    component: () => import("@/components/travel/travelDetail")
                },
                {
                    path: "travelSubmit",
                    name: "travelSubmit",
                    component: () => import("@/components/travel/travelSubmit")
                }
            ]
        },
        //定制
        {
            path: "/make",
            name: "make",
            redirect: "/make/makeHome",
            component: () => import("@/components/make/make"),
            children: [
                {
                    path: "makeHome",
                    name: "makeHome",
                    component: () => import("@/components/make/makeHome")
                },
                {
                    path: "makeSubmit",
                    name: "makeSubmit",
                    component: () => import("@/components/make/makeSubmit")
                },
                {
                    path: "makeDetail",
                    name: "makeDetail",
                    component: () => import("@/components/make/makeDetail")
                }
            ]
        },
        //商城
        {
            path: "/shopping",
            name: "shopping",
            redirect: "/shopping/shoppingHome",
            component: () => import("@/components/shopping/shopping"),
            children: [
                {
                    path: "shoppingHome",
                    name: "shoppingHome",
                    component: () =>
                        import("@/components/shopping/shoppingHome")
                },
                {
                    path: "goodsList",
                    name: "goodsList",
                    component: () => import("@/components/shopping/goodsList")
                },
                {
                    path: "goodsSubmit",
                    name: "goodsSubmit",
                    component: () => import("@/components/shopping/goodsSubmit")
                },
                {
                    path: "goodsDetail",
                    name: "goodsDetail",
                    component: () => import("@/components/shopping/goodsDetail")
                },
                {
                    path: "shoppingCart",
                    name: "shoppingCart",
                    component: () => import("@/components/shopping/shoppingCart")
                },
                {
                    path: "recommendedStore",
                    name: "recommendedStore",
                    component: () =>
                        import("@/components/shopping/recommendedStore")
                },
                {
                    path: "storeHome",
                    name: "storeHome",
                    component: () => import("@/components/shopping/storeHome")
                },
                {
                    path: "jifenList",
                    name: "jifenList",
                    component: () => import("@/components/shopping/jifenList")
                },
                {
                    path: "seckillList",
                    name: "seckillList",
                    component: () => import("@/components/shopping/seckillList")
                }
            ]
        },
        {
            path: "/",
            name: "HelloWorld",
            redirect: "/BanCar/banDan",
            component: () => import("@/components/HelloWorld"),
            children: [
                {
                    path: "BanCar",
                    name: "BanCar",
                    redirect: "/BanCar/banDan",
                    component: () => import("@/components/BanCar"),
                    children: [
                        {
                            path: "banDan",
                            name: "banDan",
                            component: () => import("@/components/banDan")
                        },
                        {
                            path: "banBack",
                            name: "banBack",
                            component: () => import("@/components/banBack")
                        }
                    ]
                },
                {
                    path: "PinCar",
                    name: "PinCar",
                    component: () => import("@/components/PinCar")
                },
                {
                    path: "BaoCar",
                    name: "BaoCar",
                    component: () => import("@/components/BaoCar")
                },
                {
                    path: "ZuCar",
                    name: "ZuCar",
                    component: () => import("@/components/ZuCar")
                },
                {
                    path: "BanHotel",
                    name: "BanHotel",
                    component: () => import("@/components/BanHotel")
                },
                {
                    path: "BanTravel",
                    name: "BanTravel",
                    component: () => import("@/components/BanTravel")
                }
            ]
        },
        {
            path: "/hotel",
            name: "Hotel",
            component: () => import("@/components/hotel")
        },
        {
            path: "/travel",
            name: "Travel",
            component: () => import("@/components/travel")
        },
        {
            path: "/car",
            name: "Car",
            redirect: "/car/BanChe/cheDan",
            component: () => import("@/components/car"),
            children: [
                {
                    path: "BanChe",
                    name: "BanChe",
                    redirect: "/car/BanChe/cheDan",
                    component: () => import("@/components/BanChe"),
                    children: [
                        {
                            path: "cheDan",
                            name: "cheDan",
                            component: () => import("@/components/cheDan")
                        },
                        {
                            path: "cheBack",
                            name: "cheBack",
                            component: () => import("@/components/cheBack")
                        }
                    ]
                },
                {
                    path: "PinChe",
                    name: "PinChe",
                    component: () => import("@/components/PinChe")
                },
                {
                    path: "BaoChe",
                    name: "BaoChe",
                    component: () => import("@/components/BaoChe")
                },
                {
                    path: "ZuChe",
                    name: "ZuChe",
                    component: () => import("@/components/ZuChe")
                }
            ]
        },
        {
            path: "/tips",
            name: "Tips",
            component: () => import("@/components/tips")
        },
        {
            path: "/method",
            name: "Method",
            component: () => import("@/components/method")
        },
        {
            path: "/shopping",
            name: "Shopping",
            component: () => import("@/components/shopping")
        },
        {
            path: "/destination",
            name: "Destination",
            component: () => import("@/components/destination")
        },
        {
            path: "/service",
            name: "Service",
            component: () => import("@/components/service")
        },
        {
            path: "/more",
            name: "More",
            component: () => import("@/components/more")
        },
        {
            path: "/login",
            name: "Login",
            component: () => import("@/components/Login")
        },
        {
            path: "/forgetMm",
            name: "forgetMm",
            component: () => import("@/components/forgetMm")
        },
        {
            path: "/register",
            name: "register",
            component: () => import("@/components/register")
        },
        {
            path: "/serviceTk",
            name: "serviceTk",
            component: () => import("@/components/serviceTk")
        },
        {
            path: "/useBanDan",
            name: "useBanDan",

            component: () => import("@/components/useBanDan")
        },
        {
            path: "/useBanBack",
            name: "useBanBack",
            component: () => import("@/components/useBanBack")
        },
        {
            path: "/identification",
            name: "identification",
            component: () => import("@/components/identification")
        },
        {
            path: "/useperMessage",
            name: "useperMessage",
            component: () => import("@/components/useperMessage")
        },
        {
            path: "/backcfCar",
            name: "backcfCar",
            component: () => import("@/components/backcfCar")
        },
        {
            path: "/usePin",
            name: "usePin",
            component: () => import("@/components/usePin")
        },
        {
            path: "/useBao",
            name: "useBao",
            component: () => import("@/components/useBao")
        },
        {
            path: "/useBaoMessage",
            name: "useBaoMessage",
            component: () => import("@/components/useBaoMessage")
        },
        {
            path: "/useZu",
            name: "useZu",
            component: () => import("@/components/useZu")
        },
        {
            path: "/useZuMessage",
            name: "useZuMessage",
            component: () => import("@/components/useZuMessage")
        },
        {
            path: "/mine",
            name: "mine",
            redirect: "/myHome",
            component: () => import("@/components/mine"),
            children: [
                {
                    path: "/myHome",
                    name: "myHome",
                    component: () => import("@/components/myHome"),
                    children: [
                        {
                            path: "",
                            name: "MBcar",
                            component: () => import("@/components/MBcar")
                        },
                        {
                            path: "MPcar",
                            name: "MPcar",
                            component: () => import("@/components/MPcar")
                        },
                        {
                            path: "MAcar",
                            name: "MAcar",
                            component: () => import("@/components/MAcar")
                        },
                        {
                            path: "MZcar",
                            name: "MZcar",
                            component: () => import("@/components/MZcar")
                        }
                    ]
                },
                {
                    path: "/payPasswd",
                    name: "payPasswd",
                    component: () => import("@/components/payPasswd")
                },
                {
                    path: "/Payword",
                    name: "Payword",
                    component: () => import("@/components/Payword")
                },
                {
                    path: "/Useperson",
                    name: "Useerson",
                    component: () => import("@/components/Useperson")
                },
                {
                    path: "/myAddress",
                    name: "myAddress",
                    component: () =>
                        import("@/components/personalcenter/myAddress")
                },
                {
                    path: "/agreeMent",
                    name: "agreeMent",
                    component: () => import("@/components/agreeMent")
                },
                {
                    path: "/bill",
                    name: "bill",
                    component: () => import("@/components/bill")
                },
                {
                    path: "/complain",
                    name: "complain",
                    component: () => import("@/components/complain")
                },
                {
                    path: "/about",
                    name: "about",
                    component: () => import("@/components/about")
                },
                {
                    path: "/contact",
                    name: "contact",
                    component: () => import("@/components/contact")
                },
                {
                    path: "/message",
                    name: "message",
                    component: () => import("@/components/message")
                },
                {
                    path: "/messageDetail",
                    name: "messageDetail",
                    component: () => import("@/components/messageDetail")
                },
                {
                    path: "/MBOrder",
                    name: "MBOrder",
                    component: () => import("@/components/MBOrder")
                },
                {
                    path: "/MPOrder",
                    name: "MPOrder",
                    component: () => import("@/components/MPOrder")
                },
                {
                    path: "/noOut",
                    name: "noOut",
                    component: () => import("@/components/noOut")
                },
                {
                    path: "/yiOut",
                    name: "yiOut",
                    component: () => import("@/components/yiOut")
                },
                {
                    path: "/ticket",
                    name: "ticket",
                    component: () => import("@/components/ticket")
                },
                {
                    path: "/couponUse",
                    name: "couponUse",
                    component: () => import("@/components/couponUse")
                },
                {
                    path: "/couponOver",
                    name: "couponOver",
                    component: () => import("@/components/couponOver")
                },
                {
                    path: "/coupon",
                    name: "coupon",
                    component: () => import("@/components/coupon")
                },
                {
                    path: "/wallet",
                    name: "wallet",
                    component: () => import("@/components/wallet")
                },
                {
                    path: "/MyMessage",
                    name: "MyMessage",
                    component: () => import("@/components/MyMessage")
                },
                {
                    path: "/noPayBMessage",
                    name: "noPayBMessage",
                    component: () => import("@/components/noPayBMessage")
                },
                {
                    path: "/noUseBMessage",
                    name: "noUseBMessage",
                    component: () => import("@/components/noUseBMessage")
                },
                {
                    path: "/noUseBservice",
                    name: "noUseBservice",
                    component: () => import("@/components/noUseBservice")
                },
                {
                    path: "/noUseBsend",
                    name: "noUseBsend",
                    component: () => import("@/components/noUseBsend")
                },
                {
                    path: "/noUseBsendWait",
                    name: "noUseBsendWait",
                    component: () => import("@/components/noUseBsendWait")
                },
                {
                    path: "/BanAccess",
                    name: "BanAccess",
                    component: () => import("@/components/BanAccess")
                },
                {
                    path: "/noPayPMessage",
                    name: "noPayPMessage",
                    component: () => import("@/components/noPayPMessage")
                },
                {
                    path: "/noConfirmPMessage",
                    name: "noConfirmPMessage",
                    component: () => import("@/components/noConfirmPMessage")
                },
                {
                    path: "/noOutPMessage",
                    name: "noOutPMessage",
                    component: () => import("@/components/noOutPMessage")
                },
                {
                    path: "/yOutAccessPMessage",
                    name: "yOutAccessPMessage",
                    component: () => import("@/components/yOutAccessPMessage")
                },
                {
                    path: "/orderCancelPMessage",
                    name: "orderCancelPMessage",
                    component: () => import("@/components/orderCancelPMessage")
                },
                {
                    path: "/addOrderPMessage",
                    name: "addOrderPMessage",
                    component: () => import("@/components/addOrderPMessage")
                },
                {
                    path: "/MOOrder",
                    name: "MOOrder",
                    component: () => import("@/components/MOOrder")
                },
                {
                    path: "/noPayOMessage",
                    name: "noPayOMessage",
                    component: () => import("@/components/noPayOMessage")
                },
                {
                    path: "/noConfirmOMessage",
                    name: "noConfirmOMessage",
                    component: () => import("@/components/noConfirmOMessage")
                },
                {
                    path: "/noOutOMessage",
                    name: "noOutOMessage",
                    component: () => import("@/components/noOutOMessage")
                },
                {
                    path: "/yOutingOMessage",
                    name: "yOutingOMessage",
                    component: () => import("@/components/yOutingOMessage")
                },
                {
                    path: "/yOutAccessOMessage",
                    name: "yOutAccessOMessage",
                    component: () => import("@/components/yOutAccessOMessage")
                },
                {
                    path: "/yOutAccessedOMessage",
                    name: "yOutAccessedOMessage",
                    component: () => import("@/components/yOutAccessedOMessage")
                },
                {
                    path: "/orderCancelOMessage",
                    name: "orderCancelOMessage",
                    component: () => import("@/components/orderCancelOMessage")
                },
                {
                    path: "/MZOrder",
                    name: "MZOrder",
                    component: () => import("@/components/MZOrder")
                },
                {
                    path: "/noPayZMessage",
                    name: "noPayZMessage",
                    component: () => import("@/components/noPayZMessage")
                },
                {
                    path: "/checkingZMessage",
                    name: "checkingZMessage",
                    component: () => import("@/components/checkingZMessage")
                },
                {
                    path: "/checkedZMessage",
                    name: "checkedZMessage",
                    component: () => import("@/components/checkedZMessage")
                },
                {
                    path: "/noConfirmZMessage",
                    name: "noConfirmZMessage",
                    component: () => import("@/components/noConfirmZMessage")
                },
                {
                    path: "/noBringZMessage",
                    name: "noBringZMessage",
                    component: () => import("@/components/noBringZMessage")
                },
                {
                    path: "/nogoingZMessage",
                    name: "nogoingZMessage",
                    component: () => import("@/components/nogoingZMessage")
                },
                {
                    path: "/finishedZMessage",
                    name: "finishedZMessage",
                    component: () => import("@/components/finishedZMessage")
                },
                {
                    path: "/cancelZMessage",
                    name: "cancelZMessage",
                    component: () => import("@/components/cancelZMessage")
                },
                {
                    path: "/addOrderZMessage",
                    name: "addOrderZMessage",
                    component: () => import("@/components/addOrderZMessage")
                },
                {
                    path: "/myTxt",
                    name: "myTxt",
                    component: () => import("@/components/personalcenter/myTxt")
                },
                {
                    path: "/myCollection",
                    name: "myCollection",
                    component: () =>
                        import("@/components/personalcenter/myCollection")
                },
                {
                    path: "/driverIn",
                    name: "driverIn",
                    component: () =>
                        import("@/components/personalcenter/driverIn")
                },
                {
                    path: "/myShopin",
                    name: "myShopin",
                    component: () =>
                        import("@/components/personalcenter/myShopin")
                },
                {
                    path: "/myIntegral",
                    name: "myIntegral",
                    component: () =>
                        import("@/components/personalcenter/myIntegral")
                },
                {
                    path: "/myTuiguang",
                    name: "myTuiguang",
                    component: () =>
                        import("@/components/personalcenter/myTuiguang")
                },
                {
                    path: "/myWay",
                    name: "myWay",
                    component: () => import("@/components/personalcenter/myWay")
                },
                /* 订单 */
                {
                    path: "/hotelOrderList",
                    name: "hotelOrderList",
                    component: () =>
                        import("@/components/everyorder/hotelOrderList")
                },
                {
                    path: "/hotelOrderDetail",
                    name: "hotelOrderDetail",
                    component: () =>
                        import("@/components/everyorder/hotelOrderDetail")
                },
                {
                    path: "/scenicOrderList",
                    name: "scenicOrderList",
                    component: () =>
                        import("@/components/everyorder/scenicOrderList")
                },
                {
                    path: "/scenicOrderDetail",
                    name: "scenicOrderDetail",
                    component: () =>
                        import("@/components/everyorder/scenicOrderDetail")
                },
                {
                    path: "/shopOrderList",
                    name: "shopOrderList",
                    component: () =>
                        import("@/components/everyorder/shopOrderList")
                },
                {
                    path: "/shopOrderDetail",
                    name: "shopOrderDetail",
                    component: () =>
                        import("@/components/everyorder/shopOrderDetail")
                },
                {
                    path: "/integralShopOrderList",
                    name: "integralShopOrderList",
                    component: () =>
                        import("@/components/everyorder/integralShopOrderList")
                },
                {
                    path: "/integralShopOrderDetail",
                    name: "integralShopOrderDetail",
                    component: () =>
                        import(
                            "@/components/everyorder/integralShopOrderDetail"
                        )
                },
                {
                    path: "/tourismOrderList",
                    name: "tourismOrderList",
                    component: () =>
                        import("@/components/everyorder/tourismOrderList")
                },
                {
                    path: "/tourismOrderDetail",
                    name: "tourismOrderDetail",
                    component: () =>
                        import("@/components/everyorder/tourismOrderDetail")
                },
                {
                    path: "/customTourismOrderList",
                    name: "customTourismOrderList",
                    component: () =>
                        import("@/components/everyorder/customTourismOrderList")
                },
                {
                    path: "/customTourismOrderDetail",
                    name: "customTourismOrderDetail",
                    component: () =>
                        import(
                            "@/components/everyorder/customTourismOrderDetail"
                        )
                }
            ]
        }
    ]
});
// 全局路由守卫

// Router.beforeEach((to, from, next) => {
//   console.log('navigation-guards');
//   const nextRoute = ['home', 'good-list', 'good-detail', 'cart', 'profile'];
//   let isLogin = global.isLogin;
//   if (nextRoute.indexOf(to.name) >= 0) {
//     if (!isLogin) {
//       console.log('what fuck');
//       router.push({ name: 'login' })
//     }
//   }
//   if (to.name === 'login') {
//     if (isLogin) {
//       router.push({ name: 'home' });
//     }
//   }
//   next();
//  });

// Router.beforeEach((to, from, next) => {
//     if(this.$store.getters.token) {
//       next();
//     } else {
//       next({ name: 'Login' });
//     }
// });



// WEBPACK FOOTER //
// ./src/router/index.js